import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Label} from '@/components/ui/label/Label'
import {useTranslation} from '@/translations/i18n'
import dayjs from 'dayjs'
import {useMemo} from 'react'

export const UserYearSelector = ({
    value,
    label,
    onChange,
    errorMessage,
    yearsFromNow = 11,
    reverseOrder
}: {
    value?: string
    label?: string
    errorMessage?: string
    onChange: (year: string) => void
    yearsFromNow?: number
    reverseOrder?: boolean
}) => {
    const {
        i18n: {t}
    } = useTranslation()

    const yearOptions = useMemo(() => {
        const currentYear = dayjs().year()
        return Array.from(
            {length: Math.abs(yearsFromNow)},
            (_, i) => currentYear + i * (yearsFromNow < 0 ? -1 : 1)
        ).reduce(
            (acc, year) => ({
                ...acc,
                [year]: year.toString()
            }),
            {}
        )
    }, [yearsFromNow])

    const isValueIncluded = (value: string) => {
        if (!value) return false
        return Object.values(yearOptions).includes(value)
    }

    return (
        <Flexbox direction="column" gap={1.5} fullWidth>
            {label && <Label>{label}</Label>}
            <InputSelect
                placeholder={t('commons:select_year')}
                errorMessage={errorMessage}
                sameWidth
                value={isValueIncluded(value || '') ? value : ''}
                onChange={onChange}
                optionsMap={yearOptions}
                reverseOrder={reverseOrder}
            />
        </Flexbox>
    )
}
